import {
  BookkeepingStatus,
  BookkeepingReportStatus,
} from '@/reducers/finances/bookkeepingReportsReducer'

// Ordered natural progression. missing_info and plaid_error are excluded.
const PROGRESSION: BookkeepingReportStatus[] = [
  BookkeepingReportStatus.not_started,
  BookkeepingReportStatus.in_progress,
  BookkeepingReportStatus.categorized,
  BookkeepingReportStatus.reconciled,
  BookkeepingReportStatus.done,
]

/**
 * Given the report's statuses array (sorted newest-first), returns the set of
 * status tiers whose bolt icon should be shown.
 *
 * A tier shows the bolt if:
 *   1. It is at or below the current status in the natural progression
 *   2. Its most recent history entry has actor='system'
 *
 * Tiers above the current status are excluded (a retreat means they are no
 * longer complete). missing_info and plaid_error are ignored entirely.
 */
export function getSystemCompletedStatuses(
  statuses: BookkeepingStatus[]
): Set<BookkeepingReportStatus> {
  const progressionStatuses = statuses.filter((s) =>
    PROGRESSION.includes(s.status)
  )

  if (progressionStatuses.length === 0) return new Set()

  // Current status = most recent progression entry (array is newest-first)
  const currentTierIndex = PROGRESSION.indexOf(progressionStatuses[0].status)

  const seen = new Set<BookkeepingReportStatus>()
  const result = new Set<BookkeepingReportStatus>()

  for (const s of progressionStatuses) {
    const tierIndex = PROGRESSION.indexOf(s.status)
    if (tierIndex > currentTierIndex) continue // above current — not complete
    if (!seen.has(s.status)) {
      seen.add(s.status)
      if (s.actor === 'system') result.add(s.status)
    }
  }

  return result
}
